// extracted by mini-css-extract-plugin
export default {"SidePanel":"SidePanel_SidePanel__8H+OF","StackedItem":"SidePanel_StackedItem__IZBuK"};